/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(id) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetProgressReport: {
        $xmlns: 'http://dobs.pa.gov/dp/enforcement/bpm/1.0',
        ID: id
      }
    },
    blueprint: {
      id: '$..ID',
      enforcementActionId: '$..EnforcementActionID',
      entityId: '$..EntityID',
      year: '$..Year',
      quarterId: '$..QuarterID',
      quarter: '$..Quarter',
      dueDate: '$..DueDate',
      submissionDate: '$..SubmissionDate',
      acknowledgmentDate: '$..AcknowledgementDate',
      statusId: '$..StatusID',
      status: '$..Status',
      comments: '$..Comments',
      isDeleted: '$..IsDeleted'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      if (response.dueDate) {
        response.dueDate = moment(response.dueDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      }
      if (response.submissionDate) {
        response.submissionDate = moment(response.submissionDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      }
      if (response.acknowledgmentDate) {
        response.acknowledgmentDate = moment(response.acknowledgmentDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      }

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
